module.exports = __webpack_public_path__ + "img/img-5.3d5f92c9.png";